import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle, MessageCircle } from 'lucide-react';
import { faqs, companyInfo } from '../mock/mock';

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="section-padding section-dark">
      <div className="container-x grid lg:grid-cols-[1fr_1.3fr] gap-12 relative">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <div className="eyebrow mb-4"><HelpCircle size={12} /> FAQ</div>
          <h2 className="section-title">Frequently asked <span className="gradient-text">questions</span></h2>
          <p className="section-subtitle mt-4">
            Everything you need to know about DC10G’s enterprise datacenter and cloud services. Still have questions? Our team is one call away.
          </p>

          <div className="mt-8 p-6 rounded-2xl glass">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-cyan-500 to-purple-600 flex items-center justify-center">
                <MessageCircle className="text-white" size={20} />
              </div>
              <div>
                <div className="text-xs text-slate-400">Talk to our specialist</div>
                <div className="font-bold text-white">Sales &amp; Solutions Team</div>
              </div>
            </div>
            <div className="mt-2 text-lg font-bold gradient-text">{companyInfo.email}</div>
            <div className="mt-1 text-slate-300 font-medium">{companyInfo.salesPhone}</div>
          </div>
        </motion.div>

        <div className="space-y-3">
          {faqs.map((f, i) => (
            <motion.div
              key={f.id}
              initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className={`rounded-xl border transition-all ${open === i ? 'border-cyan-400/40 bg-cyan-500/5' : 'border-white/10 bg-white/[0.02]'}`}
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left"
                onClick={() => setOpen(open === i ? -1 : i)}
              >
                <span className="font-semibold text-white pr-4">{f.question}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${open === i ? 'bg-gradient-to-br from-cyan-500 to-purple-600 text-white rotate-180' : 'bg-white/5 text-slate-300'}`}>
                  {open === i ? <Minus size={16} /> : <Plus size={16} />}
                </div>
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-5 pb-5 text-slate-300 leading-relaxed">{f.answer}</div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
